import {
    SET_IS_CASSETTE_EJECTING,
    SET_IS_SCAN_CANCELLED,
    SET_IS_SCANNING
} from "../redux_constants/scanWorkflow.constant";


const InitialState = {
    isCassetteEjecting: false,
    isScanCancelled: false,
    isScanningStarted: false,
}

export const scanWorkflowReducer = (state = InitialState, action) => {
    switch (action.type) {
        case SET_IS_CASSETTE_EJECTING:
            return {
                ...state,
                isCassetteEjecting: action.response,
            }
        case SET_IS_SCAN_CANCELLED:
            return {
                ...state,
                isScanCancelled: action.response,
            }
        case SET_IS_SCANNING:
            return {
                ...state,
                isScanningStarted: action.response,
            }
        default:
            return state
    }
}